<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="860px" :destroy-on-close="true"
    append-to-body :before-close="cancel">
    <div class="el-dialog-div">
      <!-- 邮寄信息 -->
      <div class="section-card">
        <div class="section-header-bar">
          <span class="section-title"><i class="el-icon-truck"></i> 邮寄信息</span>
          <i :class="sectionOpen.mailInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            @click="toggleSection('mailInfo')" style="cursor: pointer; font-size: 14px; color: #909399;"></i>
        </div>
        <div class="tab-content" v-show="sectionOpen.mailInfo">
          <div class="detail-grid">
            <div class="detail-item full-width">
              <span class="detail-label">邮寄状态</span>
              <span class="detail-value">
                <el-tag v-if="mailFlag === 'NOT_APPLYING'" type="primary" color="white">未申请</el-tag>
                <el-tag v-else-if="mailFlag === 'SUBMITTED' && selectDetail.mailAuditFlag" type="warning"
                  style="background-color: #FFFFFF">待邮寄</el-tag>
                <el-tag v-else-if="mailFlag === 'SUBMITTED' && !selectDetail.mailAuditFlag" type="warning">待审核</el-tag>
                <el-tag v-else-if="mailFlag === 'MAILED'" type="success">已邮寄</el-tag>
                <el-tag v-else-if="mailFlag === 'CANCELED'" type="warning">已取消</el-tag>
                <el-tag v-else-if="mailFlag === 'NOT_MAILED'" type="danger" style="background-color:#ffffff;">不邮寄</el-tag>
                <el-tag v-else type="info">未知状态</el-tag>
              </span>
            </div>
            <div class="detail-item" v-if="mailFlag==='CANCELED'">
              <span class="detail-label">取消原因</span>
              <span class="detail-value">{{ rejectionReason }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">创建人</span>
              <span class="detail-value">{{ createBy }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">创建时间</span>
              <span class="detail-value">{{ createTime }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">销售</span>
              <span class="detail-value">{{ applicantName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">申请时间</span>
              <span class="detail-value">{{ applicantDate }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">负责人</span>
              <span class="detail-value">{{ principalName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">收件人</span>
              <span class="detail-value">{{ recipientName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">收件人电话</span>
              <span class="detail-value">{{ recipientPhone }}</span>
            </div>
            <div class="detail-item full-width">
              <span class="detail-label">收件地址</span>
              <span class="detail-value">{{ recipientAddress }}</span>
            </div>
            <div class="detail-item full-width">
              <span class="detail-label">备注</span>
              <span class="detail-value">{{ remark }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 邮寄内容 -->
      <div class="section-card">
        <div class="section-header-bar">
          <span class="section-title"><i class="el-icon-box"></i> 邮寄内容</span>
        </div>
        <div class="tab-content">
          <mailing-content :select-detail="selectDetail"></mailing-content>
        </div>
      </div>

      <!-- 寄件单号 -->
      <div class="section-card" v-if="Object.keys(mailNumbers).length>0">
        <div class="section-header-bar">
          <span class="section-title"><i class="el-icon-tickets"></i> 寄件单号（上传时间）</span>
          <i :class="sectionOpen.mailNumbers ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            @click="toggleSection('mailNumbers')" style="cursor: pointer; font-size: 14px; color: #909399;"></i>
        </div>
        <div class="tab-content" v-show="sectionOpen.mailNumbers">
          <div class="mail-number-list">
            <div class="mail-number-item" v-for="(mailNumber,index) in Object.keys(mailNumbers)" :key="index">
              <div class="detail-grid">
                <div class="detail-item">
                  <span class="detail-label">寄件单号</span>
                  <span class="detail-value">{{ mailNumber }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">上传时间</span>
                  <span class="detail-value">{{ mailNumbers[mailNumber] }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" v-if="mailFlag==='CANCELED'" type="warning" class="title"
        @click="handleMail(id)">重新提交</el-button>
      <el-button size="small" type="primary" class="title" @click="cancel">确定</el-button>
    </div>
    <add-edit-mail v-if="showEditMail" :show-dialog="showEditMail" :selectType="{type:'edit'}"
      :select-detail="editMails" @submit="closeEditMail">
    </add-edit-mail>
  </el-dialog>
</template>

<script>

import ContractDetails from "@/components/sales/ContractDetails.vue";
import { getMailPage} from "@/api/dilivery/mail";
import FilePreview from "@/components/file/FilePreview.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import {viewDetailIcon} from "@/utils/icon";
import AddEditMail from "@/components/mail/AddEditMail.vue";
import MailingContent from "@/components/mail/MailingContent.vue";

export default {
  name: "MailDetails",
  components: {MailingContent, AddEditMail,  ExFoldTable, FilePreview, ContractDetails},
  props:['showDialog','selectDetail'],
  data(){
    return{
      title:'查看邮寄信息详情',
      showEditMail:false,
      sectionOpen: {
        mailInfo: true,
        mailNumbers: true,
      },
      editMails:'',
      id:'',
      remark:'',
      createBy:'',
      createTime:'',
      viewDetailIcon:viewDetailIcon,
      rejectionReason:'',
      operatingTime:'',
      operatingPersonName:'',
      applicantName:'',
      applicantDate:'',
      mailingContent:'',
      recipientName:'',
      expressCompany:'',
      mailAttachment: {},
      recipientPhone: '',
      recipientAddress: '',
      principalName: '',
      mailFlag: '',
      mailNumbers:{}
    }
  },
  watch:{
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.id = newVal.id
          this.remark = newVal.remark
          if(newVal.mailNumbers!==null){
            this.mailNumbers = newVal.mailNumbers
          }
          if(newVal.expressCompany!==null){
            this.expressCompany = newVal.expressCompany
          }
          this.rejectionReason = newVal.rejectionReason
          this.mailFlag = newVal.mailFlag
          this.createBy = newVal.createBy
          this.createTime = newVal.createTime
          this.applicantDate = newVal.applicantDate
          this.mailingContent = newVal.mailingContent
          if(newVal['mailPrincipal']){
            this.principalName = newVal['mailPrincipal'].name
          }
          if(newVal['applicant']!==null){
            this.applicantName = newVal['applicant'].name
          }
          this.recipientName = newVal.recipientName
          this.recipientPhone = newVal.recipientPhone
          this.recipientAddress = newVal.recipientAddress
          this.mailAttachment = {...newVal.mailAttachment}
        }
      },
      immediate:true
    },
  },
  mounted() {
  },
  methods:{
    toggleSection(key) {
      this.sectionOpen[key] = !this.sectionOpen[key];
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    closeEditMail(type) {
      this.editMails = ''
      this.showEditMail = false
      if(type === 'confirm'){
        this.$emit('submit','confirm')
      }
    },
    handleMail(id){
      let params = {
        'page.current': 1,
        'page.size': 500,
      }
      let data = {
        "query#id.EQ":id
      }
      getMailPage(params,data).then(res => {
        if(res.code === 200 && res.data.records.length>0){
          this.editMails = res.data.records[0]
          this.showEditMail = true
        }
      }).catch(error => {
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/detail.css";

.el-dialog-div {
  max-height: 90vh;
  overflow-y: auto;
  padding-right: 5px;
}

.mail-number-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mail-number-item {
  padding: 10px;
  background: #fafbfc;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}
</style>
